import { useState, useEffect } from "react";
import Loader from "components/Loader";
import CommonResultTable from "components/Tables/CommonResultTable";
import { submitKeywordAnalysisRequest } from "services/buddyXApiHubService";
import HelpCard from "components/Cards/HelpCard";
import { Button, Col, Form } from "react-bootstrap";
import Validator from "utils/Validator";
import classNames from "classnames";
import { css } from "aphrodite";
import pageStyles from "styles/pageStyles";
import { getInputFieldStyle, getButtonStyle } from "utils/formStyles";

export default function Page() {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isResultGot, setIsResultGot] = useState(false);
  const [webSite, setWebSite] = useState("");
  const [formData, setFormData] = useState({
    domainLink: "",
  });
  const [showSearchItem, setShowSearchItem] = useState("");
  const firstLevelTopic = "SEO";
  const secoundLevelTopic = "Ranking";
  const thirdLevelTopic = "Page Ranking";

  const columnNames = {
    keyword: "Keyword",
    page_url: "Page URL",
    position: "Position",
  };

  const [errors, setErrors] = useState({ domainLink: "" });
  const [data, setData] = useState([
    {
      keyword: "best running shoes",
      page_url: "https://example.com/best-running-shoes",
      position: 1,
    },
    {
      keyword: "top fitness trackers",
      page_url: "https://example.com/top-fitness-trackers",
      position: 2,
    },
    {
      keyword: "healthy meal plans",
      page_url: "https://example.com/healthy-meal-plans",
      position: 3,
    },
    {
      keyword: "home workout routines",
      page_url: "https://example.com/home-workout-routines",
      position: 4,
    },
    {
      keyword: "yoga for beginners",
      page_url: "https://example.com/yoga-for-beginners",
      position: 5,
    },
  ]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (
      name === "webSite" &&
      !Validator.validateRequired(value, Validator.validateUrl)
    ) {
      error = "Invalid URL";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleReset = () => {
    setShowSearchItem("");
    setData([]);
    setIsResultGot(false);
    setWebSite("");
    setErrors({ keyword: "" });
  };

  const handleSubmit = async () => {
    try {
      // setIsLoading(true);
      console.log(formData);
      // const result = await submitKeywordAnalysisRequest(formData,"page_ranking" ,handleInsufficientCredits);
      // console.log("Data submitted successfully:", result);
      // setData(result);
      setShowSearchItem(formData.domainLink);
      setIsResultGot(true);
    } catch (error) {
      console.error("Submission error:", error);
      setIsResultGot(false);
    }
    setIsLoading(false);
  };

  const handleWebSiteChange = (e) => {
    setWebSite(e.target.value);
  };

  useEffect(() => {
    let isValid = Validator.validateRequired(webSite, Validator.validateUrl);
    if (isValid) {
      setFormData({
        domainLink: webSite,
      });
    }
    setIsFormValid(isValid);
  }, [webSite]);

  return (
    <div className={classNames("container-fluid", css(pageStyles.container))}>
      <h1 className="d-flex fw-normal justify-content-start align-items-center fw-bold">
        {secoundLevelTopic}
      </h1>
      <p className="fw-normal justify-content-start align-items-center">
        {firstLevelTopic} / {secoundLevelTopic} / <b>{thirdLevelTopic}</b>
      </p>
      <p className="fw-normal justify-content-start align-items-center">
        Keyword ranking analysis at the given page level evaluates how specific
        webpages perform for targeted queries, providing granular insights into
        content efficacy, user intent fulfillment, and competitive positioning
        within search engine results pages (SERPs). This approach is
        particularly vital in 2025's algorithmically sophisticated environment,
        where AI personalization and zero-click searches dominate; it can
        enhance page-specific visibility by 25-40% through targeted
        optimizations, preventing resource waste on underperforming assets and
        ensuring alignment with E-E-A-T principles to sustain long-term organic
        growth and conversion potential.
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-10 col-sm-10">
          <HelpCard
            topic={"How To Use"}
            description={
              "Page Ranking helps you track how well your website pages rank in search results. Monitor your search engine performance and optimize your content strategy based on ranking data."
            }
            image={"/icon/pin.svg"}
          />
        </div>
      </div>
      <div className="p-2 mb-2 rounded">
        <div className="d-flex fw-bold mb-0">Find Your Page Rankings</div>
        <div className="row mb-2 align-items-end">
          <div className="mb-2">
            <p className="fw-normal justify-content-start align-items-center">
              Enter a website URL to check page rankings.
            </p>
            <Form.Group>
              <div className="d-flex mt-2">
                <Col sm={6} className="me-2">
                  <Form.Control
                    type="text"
                    name="webSite"
                    placeholder="Enter website URL"
                    value={webSite}
                    onChange={handleWebSiteChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.webSite}
                    required
                    className="px-2"
                  />
                </Col>
                <div className="d-flex justify-content-start align-items-end">
                  <Button
                    variant="dark"
                    className="me-1"
                    onClick={handleSubmit}
                    disabled={!isFormValid}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outline-dark"
                    className="me-1"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="p-2">
        {showSearchItem !== "" && (
          <div>
            <p className="d-flex fw-bold mb-0">
              Rankings for
              <span className="search-item">&nbsp;"{showSearchItem}"</span>
            </p>
          </div>
        )}
        {isLoading && <Loader />}
        {data.length !== 0 && (
          <CommonResultTable data={data} columnNames={columnNames} />
        )}
      </div>
    </div>
  );
}
